import {
    ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_COORDENADES,
    ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_ALTITUD
} from '../../../../actions/actionTypes';

const estatNull = {
    latitud: null,
    longitud: null,
    altitud: null
};
export const ESTAT_INICIAL = {
    originals: {...estatNull},
    editades: {...estatNull}
};

const localitzacio = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: { ...action.estructuraIDades.dades.localitzacio },
                editades: { ...action.estructuraIDades.dades.localitzacio }
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: { ...state.originals }
            };

        case ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_COORDENADES: {
            let altitud;
            if (state.editades) {
                altitud = state.editades.altitud;
            }

            let latitud, longitud;
            const { coordenades } = action;
            if (coordenades) {
                latitud = coordenades.latitud;
                longitud = coordenades.longitud;
            }

            return {
                ...state,
                editades: { latitud, longitud, altitud }
            };
        }

        case ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_ALTITUD: {
            let latitud, longitud;
            if (state.editades) {
                latitud = state.editades.latitud;
                longitud = state.editades.longitud;
            }
            return {
                ...state,
                editades: {
                    latitud,
                    longitud,
                    altitud: action.altitud
                }
            };
        }

        default:
            return state;
    }
};

export default localitzacio;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/localitzacio.js